import PropTypes from 'prop-types';
import React from "react";
import Truncate from "src/components/truncate";
import cx from "classnames";

import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Image,
} from "react-bootstrap";
import dateformat from "dateformat";
import PageAnalyticsRowView from "src/legacy/components/Analytics/Page/PageAnalyticsRowView.jsx";
import VideoAnalyticsGrapRowView from "src/legacy/components/Analytics/Video/VideoAnalyticsGraphRowView.jsx";
import AudioAnalyticsGraphRowView from "src/legacy/components/Analytics/Audio/AudioAnalyticsGraphRowView.jsx";
import VideoAnalyticsSegmentRowView from "src/legacy/components/Analytics/Video/VideoAnalyticsSegmentRowView.jsx";
import AudioAnalyticsSegmentRowView from "src/legacy/components/Analytics/Audio/AudioAnalyticsSegmentRowView.jsx";

import { FileService }  from "src/services/file.service"
import Tooltip from 'src/components/tooltip';

import styles from "./styles.module.scss";
import AssetDefaultIcon from "src/legacy/images/defaultAsset.jpg";
import PlayButton from "../PlayButton";
import { localizedStrings } from 'src/localization/index.jsx';

class AssetShareView extends React.Component {
  constructor(props) {
    super(props);

    var hasAnalytics = false;
    if (FileService.hasAnalytics(this.props.asset.metadata)) {
      hasAnalytics = true;
    }

    this.state = {
      pages: [],
      pageCount: 0,
      hasAnalytics: hasAnalytics,
      loadingAnalytics: false,
      fetchedAnalytics: false,
      activePage: null,
      chart: {
        width: 250,
        visible: false,
      },
    };

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedConversations = localizedStrings.pages.conversations;
    this.localizedDetails = this.localizedConversations.detail_view;
  }

  componentDidMount() {
    if (
      this.props.shouldFetchAnalytics &&
      this.state.hasAnalytics &&
      this.props.asset.analytics.fetch &&
      !this.state.fetchedAnalytics
    ) {
      this.props.fetchAssetAnalytics(this.props.sectionId, this.props.asset);

      this.setState({
        fetchedAnalytics: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.shouldFetchAnalytics &&
      this.state.hasAnalytics &&
      nextProps.asset.analytics &&
      nextProps.asset.analytics.fetch &&
      !this.state.fetchedAnalytics
    ) {
      this.props.fetchAssetAnalytics(nextProps.sectionId, nextProps.asset);

      this.setState({
        fetchedAnalytics: true,
      });
    }

    if (
      nextProps.asset.analytics &&
      nextProps.asset.analytics.loading != this.props.asset.analytics.loading
    ) {
      this.setState({
        loadingAnalytics: nextProps.asset.analytics.loading,
      });
    }
  }

  render() {
    var assetViewEvent = null;
    var downloadViewEvent = null;

    const timeSpent = this.props.asset.totalTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    if (this.props.events) {
      this.props.events.forEach((event) => {
        switch (event.type) {
          case "asset_viewed":
            assetViewEvent = event;
            break;
          case "asset_download":
            downloadViewEvent = event;
            break;

          default:
            break;
        }
      });
    }

    var url = "";

    if(this.props.conversation){
      url = `/assets/${this.props.asset.id}/?source=conversations/${this.props.conversation.id}`
    }else{
      url = `/assets/${this.props.asset.id}`;
    }

    return (
      <Row className={cx(styles.asset, this.props.className)}>
        <Col xl={6} md={6} className={styles.noPadding}>
      
            <Link
              to={url}
              className={styles.assetLink}
            >
          <div className={styles.iconContainer}>
            {this.props.asset.metadata && (
              <PlayButton
                asset={this.props.asset}
                className={styles.playButton}
                size={35}
              />
            )}
            <Image className={styles.icon} src={this.renderAssetIcon()} />
          </div>
          <div className={styles.assetInfo}>
          <div className={styles.name}>
            <Truncate lines={1} width={150}>{this.props.asset.name}</Truncate>
          </div>
          <Col sm={12} className={cx(styles.assetMetrics, styles.noPadding)}>
            <Tooltip content={assetViewEvent
                    ? `${this.localizedCommons.last_viewed_on} ${dateformat(
                        assetViewEvent.createdDate,
                        "dd mmm yyyy"
                      )}`
                    : this.localizedCommons.not_viewed}>
              <div className={styles.metrics}>
                <span className="paperflite-eye"></span>
                <label>{assetViewEvent ? assetViewEvent.count : 0}</label>
              </div>
            </Tooltip>
            <Tooltip content={downloadViewEvent
                    ? `${this.localizedCommons.last_downloaded_on} ${dateformat(
                        downloadViewEvent.createdDate,
                        "dd mmm yyyy"
                      )}`
                    : this.localizedCommons.not_downloaded} >
              <div className={styles.metrics}>
                <span className="paperflite-download"></span>
                <label>{downloadViewEvent ? downloadViewEvent.count : 0}</label>
              </div>
              </Tooltip>

            <div className={styles.metrics}>
              <span className="paperflite-clock"></span>
              <label>{timeSpentValue}</label>
            </div>
          </Col>
          </div>
            </Link>
          
        </Col>
        {this.props.showAnalytics && (
          <Col md={6} xl={6} className={styles.analyticsColumn}>
            {this.state.hasAnalytics &&
              !this.state.loadingAnalytics &&
              assetViewEvent &&
              this.renderAnalytics(assetViewEvent)}

            {this.state.hasAnalytics && this.state.loadingAnalytics && (
              <div className={styles.loadingMessage}>{this.localizedCommonLoading.analytics}...</div>
            )}

            {this.state.hasAnalytics &&
              !this.state.loadingAnalytics &&
              !assetViewEvent && (
                <div className={styles.emptyMessage}>{this.localizedDetails.error_messages.no_activity_recorded}</div>
              )}

            {!this.state.hasAnalytics && assetViewEvent && (
              <div className={styles.emptyMessage}>
                {this.localizedDetails.asset_analytics.last_viewed}{" "}
                {dateformat(assetViewEvent.createdDate, "dd mmm yyyy")}
              </div>
            )}
          </Col>
        )}
      </Row>
    );
  }

  renderAssetIcon() {
    var icon = AssetDefaultIcon;
    if (this.props.asset.icon) {
      icon = this.props.asset.icon.thumbnail;
    }

    return icon;
  }

  renderAnalytics(event) {
    var analytics =
      this.props.asset.analytics && this.props.asset.analytics.item;

    if (!analytics) {
      return false;
    }

    if (analytics.type === "PAGE_ANALYTICS") {
      return (
        <PageAnalyticsRowView
          asset={this.props.asset}
          analytics={analytics}
          lastViewedDate={event.createdDate}
          preview={this.props.asset.preview}
          renderWithin="conversation"
        />
      );
    } else if (analytics.type == "VIDEO_ANALYTICS") {
      if (this.props.renderWithin === "conversation") {
        return (
          <VideoAnalyticsGrapRowView
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      } else if (this.props.renderWithin === "contact") {
        return (
          <VideoAnalyticsSegmentRowView
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      }
    } else if (analytics.type === "AUDIO_ANALYTICS") {
      if (this.props.renderWithin === "contact") {
        return (
          <AudioAnalyticsSegmentRowView
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      } else if (this.props.renderWithin === "conversation") {
        return (
          <AudioAnalyticsGraphRowView
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      }
    }

    return false;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }

    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}
export default AssetShareView;
